export const API = 'https://songbirdapi2.pcyc.org.au/api/';
export const APP = 'https://songbird2.pcyc.org.au';
export const MOBILE_APP = 'https://songbirdmobile2.pcyc.org.au';export const DEPLOYED_VERSION='35c8081360d21bfc7ed9bf3efca553ecb6d625ac'
